import React from "react";
import {t} from "i18next";

function TermsOfUsePL(){

    return(
        <div>
            <div className="policy">
                <h3 className="title">{t('policy_template_philips.terms_of_use.title')}</h3>
                <h3 className="title">{t('policy_template_philips.terms_of_use.subtitle')}</h3>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p1')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p2')}{t('policy_template_philips.terms_of_use.p3')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p4')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p5')}{t('policy_template_philips.terms_of_use.p6')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p7')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p8')}{t('policy_template_philips.terms_of_use.p9')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p10')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p11')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section1')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p12')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section2')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p13')}{t('policy_template_philips.terms_of_use.p14')}{t('policy_template_philips.terms_of_use.p15')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p16')}{t('policy_template_philips.terms_of_use.p17')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section3')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p18')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section4')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p19')}{t('policy_template_philips.terms_of_use.p20')}{t('policy_template_philips.terms_of_use.p21')}{t('policy_template_philips.terms_of_use.p22')}{t('policy_template_philips.terms_of_use.p23')}{t('policy_template_philips.terms_of_use.p24')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p25')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p26')}{t('policy_template_philips.terms_of_use.p27')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section5')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p28')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p29')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p30')}{t('policy_template_philips.terms_of_use.p31')}{t('policy_template_philips.terms_of_use.p32')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section6')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p33')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p34')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p35')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p36')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section7')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p37')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p38')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section8')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p39')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p40')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section9')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p41')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section10')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p42')}</p>
                <br></br>
                <p className="bold">{t('policy_template_philips.terms_of_use.section11')}</p>
                <br></br>
                <p>{t('policy_template_philips.terms_of_use.p43')}</p>
                <br></br>
            </div>
        </div>
    )
}

export default TermsOfUsePL